import {
  CreateLinkDialog as ScribeCreateLinkDialog,
  type LinkArtifactInput,
} from '@github-ui/scribe-artifacts/CreateLinkDialog'
import {useCallback} from 'react'

import type {CreateArtifactDialogProps} from './create-artifact-dialog-types'
import {useCreateArtifactSubmit} from './use-create-artifact-submit'

export function CreateLinkDialog({
  resourceId,
  onClose,
  onCreated,
  returnFocusRef,
  artifact,
}: CreateArtifactDialogProps) {
  const {clearCreateErrorMessage, createErrorMessage, isPending, submitArtifact} = useCreateArtifactSubmit({
    resourceId,
    artifactNumber: artifact?.number,
    onClose,
    onCreated,
    errorMessage: artifact ? 'Link could not be updated. Try again.' : 'Link could not be added. Try again.',
  })

  const handleSubmit = useCallback(
    ({name, body}: LinkArtifactInput) => {
      submitArtifact({
        name,
        body,
        type: 'link',
      })
    },
    [submitArtifact],
  )

  return (
    <ScribeCreateLinkDialog
      artifact={artifact}
      errorMessage={createErrorMessage}
      isPending={isPending}
      onClose={onClose}
      onInputChange={clearCreateErrorMessage}
      onSubmit={handleSubmit}
      returnFocusRef={returnFocusRef}
    />
  )
}
